module.exports = __webpack_public_path__ + "static/img/stamp_12.7ff267f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keepgoing/stamp_12.jpg
// module id = Kfnd
// module chunks = 7